export const CONFIG = {
  API_ENDPOINT: "https://see.dev.fegno.com/api/v1/",
  RESULTS_PER_PAGE: 10,
  GOOGLE_API_KEY: "AIzaSyDHXnWbj6nE--h0jDByllOPJ-F7dST-048",
};
